import { InjectionToken } from '@angular/core';

export const OCL_GLOBAL_INSTRUCTION_MODAL_TOKEN = new InjectionToken<any>('OclGlobalInstructionModalComponent');
